<template>
	<b-modal ref="summaryResultsModal" id="summaryResultsModal" :header-bg-variant="'secondary'" no-close-on-esc no-close-on-backdrop hide-backdrop>
		<template slot="modal-header" slot-scope="{ close }">
			<h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'users']" size="1x" class="mr-2"/> {{t('updateCustomersSendOptionsSuccess', 'updateCustomersSendOptionsSuccess')}}</h5>
			<button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close();hideBackdrop();"><span aria-hidden="true" class="text-light">X</span></button>
		</template>
		<template v-slot:default>
			<table class="table table-striped">
				<tbody>
					<tr v-for="(stat,i) in $props.report" :key="i">
						<template>
							<th scope="row">{{ t(i,i) }}</th>
							<td v-if="Array.isArray(stat)">
								<span v-for="(el,i) in stat" :key="i">
								{{ el }} {{ ((stat.length - 1) != (Number(i) ))? ',' : '' }}
								</span>
							</td>
							<td v-else>{{ stat }}</td>
						</template>
					</tr>
				</tbody>
			</table>
		</template>
		<template v-slot:modal-footer="{ close }">
			<button aria-label="Close" data-dismiss="modal" class="btn btn-secondary" type="button" @click="close();hideBackdrop();">
				<fontAwesomeIcon :icon="['fa', 'times']" class="text-light mr-2"/>{{ t('closeButtonText', 'closeButtonText')}}
			</button>
		</template>
	</b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalSummaryResults',
  props: ['report'],
  methods: {
		// NS-9835 SP
		hideBackdrop() {
			this.$parent.overlayBackgroundDisplay = false
			this.$store.dispatch('alertClearResponse')
		}		
  }
}
</script>

<style scoped>

</style>
